import { Box, tooltipClasses, TooltipProps, Tooltip as MTooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000',
    color: 'white',
    minWidth: '8rem',
    fontSize: '1rem',
    lineHeight: theme.typography.pxToRem(18),
    padding: '1rem',
    textAlign: 'center',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000',
  },
}));

interface TruncatedTooltipProps {
  label: string;
  limit: number;
  truncateEnd?: boolean;
}

function TruncatedTooltip({ label, limit, truncateEnd = false }: TruncatedTooltipProps) {
  const maxLength = truncateEnd ? limit : 2 * limit;

  /**
   * Truncates the strings to leave only the first and last elements, or only the first ones when truncating the end
   * @param str
   */
  const truncateString = (str: string) =>
    truncateEnd ? `${str.slice(0, limit)}...` : `${str.slice(0, limit)}...${str.slice(-limit)}`;

  return label.length <= maxLength ? (
    <span>{label}</span>
  ) : (
    <Box sx={{ display: 'flex' }}>
      <Tooltip arrow title={`${label}`} placement="top" disableHoverListener={!label}>
        <span>{truncateString(label)}</span>
      </Tooltip>
    </Box>
  );
}

export default memo(TruncatedTooltip);
